import { gql } from '__generated__';

export default gql(`
  mutation AddProduct($input: AddProductInput!) {
    addProduct(input: $input) {
      id
    }
  }
`);
